import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Button, Spinner, Form } from "react-bootstrap";
import { Link, useParams } from 'react-router-dom';
import { DatiIntestatario } from "../../../../components/Ordini/DatiIntestatario";
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { format } from 'date-fns';
import { sports } from "../../../../components/Util/enum";
import { useProfile } from "../../../../../hooks/useProfile";
import { etichettaPagamento, OMAGGIO } from "../../../../components/Vendite/formePagamento";

import { conMotivo } from "../../../../components/Util/erroreServer";
import { usePageTitle, useStatoInSolaLettura } from "../../../../layouts/PageHeaderExtra";
// Prodotto di questa pagina: nome, id per il link alla scheda e tipo mostrato
const PRODUCT = { type: 'Lezione', nameField: 'lesson_name', idFields: ['lesson_id', 'lessonId'], path: '/struttura/booking/lessonsview/' };

// Date e importi in formato italiano; vuoti se il valore manca o non e' valido
const toDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
};
const fmtDate = (value) => {
    const date = toDate(value);
    return date ? format(date, 'dd/MM/yyyy') : '';
};
const fmtTime = (value) => {
    const date = toDate(value);
    return date ? format(date, 'HH:mm') : '';
};
const fmtEuro = (value) => {
    const amount = Number(value);
    if (value === null || value === undefined || value === '' || isNaN(amount)) return '-';
    return amount.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
};

export const UserLessonsEdit = () => {

    const { profile, loading: profileLoading } = useProfile();
    const isFatturazioneConfirmed = profile?.club?.invoiceDataSender?.status === 'CONFIRMED';

    const { id } = useParams();
    // Incrementato per ricaricare i dati senza ricaricare la pagina
    const [reloadKey, setReloadKey] = useState(0);
    // Risposta completa dell'API: alimenta intestazione, articolo e cronologia
    const [order, setOrder] = useState(null);

	const [loadingShowed, setLoadingShowed] = useState(false);
    const [confirmPaymentShowed, setConfirmPaymentShowed] = useState(false);
	const [confirmShowed, setConfirmShowed] = useState(false);
	const [onContinue, setOnContinue] = useState(null);
    const [confirmText, setConfirmText] = useState('');

    const optionsPayment = [
        { value: "CASH", label: "Contanti" },
        { value: "CARD", label: "Carta di credito" },
        { value: "BANK_TRANSFER", label: "Bonifico" }
    ]

    const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const userBookingLessons = await apiClient.getUserBookingLessonById(token, id);
					setLoadingShowed(false);
                    
                    if(userBookingLessons) {
                        const elementFormData = {
                            lesson_name: userBookingLessons.lesson_name,
                            sportType: sports.find(s => s.value === userBookingLessons.sportType)?.label || userBookingLessons.sportType,
                            playerName: userBookingLessons.playerName,
                            juniorName: userBookingLessons.juniorName,
                            price: userBookingLessons.price+' €',
                            startDate: userBookingLessons.bookingDate && userBookingLessons.startTime ? 
                                format(new Date(userBookingLessons.bookingDate), 'dd/MM/yyyy') + ' ' + userBookingLessons.startTime : '',
                            endDate: userBookingLessons.bookingDate && userBookingLessons.endTime ? 
                                format(new Date(userBookingLessons.bookingDate), 'dd/MM/yyyy') + ' ' + userBookingLessons.endTime : '',
                        }

                        let status = null;
                        if(userBookingLessons.status === 'PAID') {
                            // L'omaggio è chiuso come un pagato, ma non è un incasso:
                            // nella scheda si legge per quello che è.
                            status = userBookingLessons.payment_method === OMAGGIO
                                ? {
                                    "label": "Omaggio",
                                    "class": "text-info"
                                }
                                : {
                                    "label": "Pagato",
                                    "class": "text-success"
                                };
                        } else if(userBookingLessons.status === 'UNPAID') {
                            status = {
                                "label": "Non pagato",
                                "class": "text-primary"
                            };
                        } else if(userBookingLessons.status === 'REFUNDED') {
                            status = {
                                "label": "Rimborsato",
                                "class": "text-warning"
                            };
                        } else if(userBookingLessons.status === 'CANCELLED') {
                            status = {
                                "label": "Eliminato",
                                "class": "text-error"
                            };
                        }

                        elementFormData.id = userBookingLessons.id;
                        elementFormData.status = status;
                        elementFormData.originalStatus = userBookingLessons.status;

                        if(userBookingLessons.receiver) {
                            elementFormData.codice_fiscale = userBookingLessons.receiver.tax_code;
                            elementFormData.email = userBookingLessons.receiver.pec;
                            elementFormData.indirizzo = userBookingLessons.receiver.address;
                            elementFormData.cap = userBookingLessons.receiver.zip_code;
                            elementFormData.citta = userBookingLessons.receiver.city;
                            elementFormData.provincia = userBookingLessons.receiver.province;
                            elementFormData.nazione = userBookingLessons.receiver.country || 'Italia';
                            if(userBookingLessons.receiver.type === 'consumer') {
                                elementFormData.tipo_cliente = 'privato';
                                elementFormData.nome = userBookingLessons.receiver.first_name;
                                elementFormData.cognome = userBookingLessons.receiver.last_name;
                            } else if(userBookingLessons.receiver.type === 'business') {
                                elementFormData.tipo_cliente = 'azienda';
                                elementFormData.ragione_sociale = userBookingLessons.receiver.denomination;
                                elementFormData.partita_iva = userBookingLessons.receiver.vat_number;
                                elementFormData.codice_destinatario = userBookingLessons.receiver.sdi_code;
                            }
                        }

                        if(userBookingLessons.status !== 'UNPAID') {
                            elementFormData.is_pagato = true;
                            if(userBookingLessons.payment_method) {
                                elementFormData.modalita_pagamento = userBookingLessons.payment_method;
                            }
                        } else {
                            elementFormData.is_pagato = false;
                        }

                        // Aggiungi il campo skip_generate_document con valore di default
                        elementFormData.skip_generate_document = false;

                        setOrder(userBookingLessons);
                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [id, reloadKey]);

    const [formData, setFormData] = useState({
        lesson_name: '',
        sportType: '',
        playerName: '',
        juniorName: '',
        price: '',
        status: '',
        startDate: '',
        endDate: '',
        codice_fiscale: '',
        email: '',
        indirizzo: '',
        cap: '',
        citta: '',
        provincia: '',
        nazione: '',
        tipo_cliente: '',
        ragione_sociale: '',
        partita_iva: '',
        codice_destinatario: '',
        nome: '',
        cognome: '',
        skip_generate_document: false
    });

    useEffect(() => {
        if (!profileLoading && profile && !isFatturazioneConfirmed && formData.skip_generate_document !== true) {
            setFormData(prev => ({ ...prev, skip_generate_document: true }));
        }
    }, [profileLoading, profile, isFatturazioneConfirmed, formData.skip_generate_document]);

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const goBack = () => {
        window.history.back();
	};

	const deleteDetail = (row) => {
        setOnContinue(() => () => continueDelete(row));
        setConfirmShowed(true);
        setConfirmText("Sei sicuro di volere continuare? L'acquisto sarà eliminato.");
    };

    const continueDelete = (row) => {
    
        setConfirmShowed(false);

        const deleteData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const deleteResult = await apiClient.setCancelledUserLesson(token, row.id, '');
                    setLoadingShowed(false);

                    if(!deleteResult) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText(conMotivo("Si è verificato un errore durante l'eliminazione"));
                        setModalShowed(true);
                    } else {
                        window.history.back();
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        deleteData();
    };

    const paymentDetail = (row) => {
        setConfirmPaymentShowed(true);
    };

    const continuePayment = (row) => {

        console.log(formData);

        if(!formData.modalita_pagamento) {
            setModalTitle("Errore durante l'operazione");
            setModalText("Devi selezionare una modalità di pagamento per procedere.");
            setModalShowed(true);
            return;
        }
    
        setConfirmPaymentShowed(false);

        const deleteData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const deleteResult = await apiClient.setPayedUserLesson(token, row.id, formData.modalita_pagamento, formData.skip_generate_document);
                    setLoadingShowed(false);

                    if(!deleteResult) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText(conMotivo("Si è verificato un errore durante la cancellazione"));
                        setModalShowed(true);
                    } else {
                        window.history.back();
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        deleteData();
    };

    const refundDetail = (row) => {
        setOnContinue(() => () => continueRefund(row));
        setConfirmShowed(true);
        setConfirmText("Sei sicuro di volere continuare? L'acquisto sarà impostato come rimborsato. Nessun documento verrà emesso.");
    };

    const continueRefund = (row) => {
    
        setConfirmShowed(false);

        const deleteData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const deleteResult = await apiClient.setRefundedUserLesson(token, row.id, '');
                    setLoadingShowed(false);

                    if(!deleteResult) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText(conMotivo("Si è verificato un errore durante la cancellazione"));
                        setModalShowed(true);
                    } else {
                        setReloadKey((k) => k + 1);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        deleteData();
    };


    // Ordine così come arriva dall'API: intestazione, articolo, cronologia
    const o = order || {};
    const orderLabel = o.orderID || (o.id ? `#${String(o.id).slice(0, 8)}` : '');
    // Titolo della pagina = l'ordine aperto; finché non è caricato resta quello generico
    usePageTitle(orderLabel ? `Ordine ${orderLabel}` : '');
    // Stato dell'ordine in sola lettura subito dopo il titolo (regola SUI); si cambia con le azioni in fondo
    useStatoInSolaLettura(formData.status?.label, formData.originalStatus === 'PAID' ? 'attivo' : formData.originalStatus === 'UNPAID' ? 'non-attivo' : 'bozza');
    const createdAt = toDate(o.createdAt);
    const productName = o[PRODUCT.nameField] || '';
    const productId = PRODUCT.idFields.map(field => o[field]).find(Boolean);
    const sportLabel = sports.find(s => s.value === o.sportType)?.label || o.sportType;
    let periodo = '';
    if (o.bookingDate) {
        periodo = [fmtDate(o.bookingDate), [o.startTime, o.endTime].filter(Boolean).join('–')].filter(Boolean).join(' · ');
    } else if (toDate(o.startDate) && toDate(o.endDate)) {
        periodo = `dal ${fmtDate(o.startDate)} al ${fmtDate(o.endDate)}`;
    } else if (toDate(o.startDate)) {
        periodo = `dal ${fmtDate(o.startDate)}`;
    }
    const price = Number(o.price);
    const listPrice = Number(o.list_price);
    const hasListPrice = o.list_price !== null && o.list_price !== undefined && o.list_price !== '' && !isNaN(listPrice) && listPrice !== price;
    const discount = hasListPrice && !isNaN(price) ? listPrice - price : 0;
    const methodLabel = etichettaPagamento(o.payment_method);
    const invoiceNumber = o.invoice_number_str || '';
    const paymentDate = toDate(o.paymentDate);
    const refundDate = toDate(o.refundDate);


    // Cronologia: solo gli eventi di cui c'è il dato, dal più vecchio
    const timeline = [
        createdAt && { key: 'created', label: 'Ordine creato', date: createdAt },
        paymentDate && { key: 'paid', label: 'Pagamento registrato', detail: methodLabel, date: paymentDate },
        invoiceNumber && { key: 'document', label: 'Documento emesso', detail: `n. ${invoiceNumber}` },
        refundDate && { key: 'refunded', label: 'Rimborsato', detail: o.refundNote, date: refundDate },
    ].filter(Boolean);

    const playerPicture = o.playerPicture?.uri || (typeof o.playerPicture === 'string' ? o.playerPicture : '');

    // Dati di fatturazione: solo le righe con un valore
    const isAzienda = formData.tipo_cliente === 'azienda';
    const recipientName = isAzienda
        ? formData.ragione_sociale
        : [formData.nome, formData.cognome].filter(Boolean).join(' ');
    const recipientRows = [
        ['Tipo', formData.tipo_cliente ? (isAzienda ? 'Azienda' : 'Privato') : ''],
        ['P. IVA', isAzienda ? formData.partita_iva : ''],
        ['Cod. fiscale', formData.codice_fiscale],
        ['SDI', isAzienda ? formData.codice_destinatario : ''],
        ['PEC / Email', formData.email],
        ['Indirizzo', formData.indirizzo],
        ['CAP', formData.cap],
        ['Città', formData.citta],
        ['Provincia', formData.provincia],
        ['Nazione', formData.nazione],
    ].filter(([, value]) => value);
    const hasRecipient = Boolean(recipientName) || recipientRows.length > 0;

	return (
		<>
			<Modal className="fade" show={confirmPaymentShowed} centered>
				<Modal.Header>
					<Modal.Title>Sei sicuro?</Modal.Title>
					<Button onClick={() => setConfirmPaymentShowed(false)} variant="" className="btn-close">
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col className="col-xl-64">
							Sei sicuro di volere continuare? L'acquisto sarà impostato come pagato. <b>Attenzione!</b> Procedendo il corrispondente documento fiscale verrà emesso e inviato se abilitato per la tua struttura.
						</Col>
					</Row>
					<Row className="mt-4">
						<Col className="col-xl-64">
							<Form.Label>Modalità di pagamento</Form.Label>
							<Select
                                placeholder="Seleziona la modalità di pagamento"
								className="mt-2"
								name="modalita_pagamento"
                                value={optionsPayment.find(option => option.value === formData.modalita_pagamento) || null}
								onChange={(selectedOption) => handleSelectChange(selectedOption, "modalita_pagamento")} 
								options={optionsPayment}
							/>
						</Col>
					</Row>
					<Row className="mt-4">
						<Col className="col-xl-64">
							<Form.Label>Genera documento</Form.Label>
							<Select
                                isDisabled={!isFatturazioneConfirmed}
								className="mt-2"
								name="skip_generate_document"
								placeholder="Seleziona"
								value={[{value: false, label: 'Si'}, {value: true, label: 'No'}].find(option => option.value === formData.skip_generate_document) || null}
								onChange={(selectedOption) => handleSelectChange(selectedOption, "skip_generate_document")} 
								options={[{value: false, label: 'Si'}, {value: true, label: 'No'}]}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-light btn-add" onClick={() => setConfirmPaymentShowed(false)}>
						Chiudi
					</Button>
					<Button className="btn btn-primary btn-add" onClick={() => continuePayment(formData)}>
						Continua
					</Button>
				</Modal.Footer>
			</Modal>
            
            <Modal className="fade" show={confirmShowed} centered>
                <Modal.Header>
                    <Modal.Title>Sei sicuro?</Modal.Title>
                    <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{confirmText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
                        Chiudi
                    </Button>
					<Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
                        Continua
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>


            <Row className="g-4">
                <Col md={8} className="sid-order-col">
                    <Card className="sid-order-card">
                        <Card.Body>
                            <div className="sid-order-header">
                <div className="sid-order-header__main">
                    <div className="sid-order-header__title-row">
                        <h2 className="sid-order-header__title">Ordine {orderLabel}</h2>
                    </div>
                    {createdAt && <div className="sid-order-header__meta">Creato il {fmtDate(createdAt)} alle {fmtTime(createdAt)}</div>}
                </div>
            </div>
                            <h5 className="sid-order-card__title">Articolo</h5>
                            <div className="sid-line-item">
                                <div className="sid-line-item__thumb" aria-hidden="true">{PRODUCT.type.charAt(0)}</div>
                                <div className="sid-line-item__info">
                                    <div className="sid-line-item__name">
                                        {productId
                                            ? <Link to={`${PRODUCT.path}${productId}`}>{productName || PRODUCT.type}</Link>
                                            : (productName || PRODUCT.type)}
                                    </div>
                                    <div className="sid-line-item__meta">{[PRODUCT.type, sportLabel].filter(Boolean).join(' · ')}</div>
                                    {periodo && <div className="sid-line-item__meta">{periodo}</div>}
                                    {o.coach_name && <div className="sid-line-item__meta">con {o.coach_name}</div>}
                                    {o.juniorName && <div className="sid-line-item__meta">per {o.juniorName}</div>}
                                </div>
                                <div className="sid-line-item__price">{fmtEuro(o.price)}</div>
                            </div>
                            <dl className="sid-order-totals">
                                {hasListPrice && (
                                    <>
                                        <dt>Prezzo di listino</dt>
                                        <dd>{fmtEuro(listPrice)}</dd>
                                    </>
                                )}
                                {discount > 0 && (
                                    <>
                                        <dt>Sconto</dt>
                                        <dd>− {fmtEuro(discount)}</dd>
                                    </>
                                )}
                                <dt className="is-total">Totale</dt>
                                <dd className="is-total">{fmtEuro(o.price)}</dd>
                            </dl>
                        </Card.Body>
                    </Card>

                    <Card className="sid-order-card">
                        <Card.Body>
                            <h5 className="sid-order-card__title">Cronologia</h5>
                            {timeline.length > 0 ? (
                                <ol className="sid-timeline">
                                    {timeline.map(event => (
                                        <li key={event.key} className="sid-timeline__item">
                                            <div className="sid-timeline__label">{event.label}</div>
                                            {event.detail && <div className="sid-timeline__detail">{event.detail}</div>}
                                            {event.date && <div className="sid-timeline__date">{fmtDate(event.date)} alle {fmtTime(event.date)}</div>}
                                        </li>
                                    ))}
                                </ol>
                            ) : (
                                <div className="sid-order-muted">Nessun evento registrato</div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={4} className="sid-order-col">
                    <Card className="sid-order-card">
                        <Card.Body>
                            <DatiIntestatario playerId={o.playerId} playerName={o.playerName} playerPicture={playerPicture} juniorName={o.juniorName} />
                            <div className="sid-order-sep" aria-hidden="true" />
                            <h5 className="sid-order-card__title">Dati fatturazione</h5>
                            {hasRecipient ? (
                                <>
                                    <dl className="sid-recipient__list">
{recipientName && (<><dt>Nome</dt><dd>{recipientName}</dd></>)}
                                        {recipientRows.map(([label, value]) => (
                                            <React.Fragment key={label}>
                                                <dt>{label}</dt>
                                                <dd>{value}</dd>
                                            </React.Fragment>
                                        ))}
                                    </dl>
                                </>
                            ) : (
                                <div className="sid-order-muted">Nessun dato di fatturazione</div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Azioni dell'ordine in fondo alla pagina, dopo tutti i box. «Rimborsa» resta
                visibile anche quando non si può fare, così si capisce che esiste. */}
            <div className="d-flex justify-content-end gap-4 mt-4">
                <Button size="sm" variant="dark" className="light sid-btn-compact" onClick={() => goBack()}>Indietro</Button>
                <Button
                    size="sm"
                    variant="primary"
                    className="light sid-btn-compact"
                    disabled={formData.originalStatus !== 'PAID'}
                    title={formData.originalStatus !== 'PAID' ? 'Si può rimborsare solo un ordine pagato' : undefined}
                    onClick={() => refundDetail(formData)}>
                    Rimborsa
                </Button>
                {formData.originalStatus === 'UNPAID' && (
                    <Button size="sm" variant="primary" className="light sid-btn-compact" onClick={() => deleteDetail(formData)}>Elimina</Button>
                )}
                {formData.originalStatus === 'UNPAID' && (
                    <Button size="sm" variant="primary" className="sid-btn-compact" onClick={() => paymentDetail(formData)}>Registra pagamento</Button>
                )}
            </div>
		</>
	)

}
export default UserLessonsEdit;